import { Component, inject, input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'syn-pages-header',
  templateUrl: './pages-header.component.html',
  styleUrls: ['./pages-header.component.scss'],
})
export class PagesHeaderComponent {
  private readonly _location = inject(Location);
  private readonly _router = inject(Router);

  readonly title = input<string>(undefined);
  readonly subTitle = input<string>(undefined);
  readonly previousPage = input<string>(undefined);

  goBack() {
    const previousPage = this.previousPage();
    console.log('previousPage', previousPage);
    if (previousPage) {
      this._router.navigate([previousPage], { queryParams: {} });
    } else {
      this._location.back();
    }
  }
}
